import { PAGE_ID } from '../../constants/checkboxPluginConfig';
import { loadScript } from '../load-script';
import { IS_PROD_URL } from './constants';

export const initXrayScript = () => {
  const globalJavascriptBaseUrl = 'mm-uxrv.com';

  const url = `https://${globalJavascriptBaseUrl}/js/${PAGE_ID}.js`;
  if (IS_PROD_URL) {
    loadScript({
      id: 'xray-script',
      src: url,
      async: true,
    });
  }
};
